export enum AccountSubdomain {
  MSC = 'msc',
  POSTAL = 'postal',
  LPC = 'lpc',
  DHTX = 'dhtx',
  PEPSICO = 'pepsico',
}
